import { render, staticRenderFns } from "./ROEditExpeditionFee.vue?vue&type=template&id=703f15f4&scoped=true&"
import script from "./ROEditExpeditionFee.vue?vue&type=script&lang=js&"
export * from "./ROEditExpeditionFee.vue?vue&type=script&lang=js&"
import style0 from "./ROEditExpeditionFee.vue?vue&type=style&index=0&id=703f15f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703f15f4",
  null
  
)

export default component.exports